import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useFetchUserMeetingTranscript } from 'actions/users';
import getBasicDate from 'utils/dates/getBasicDate';
import sanitizeForFileName from 'utils/file/sanitizeForFileName';
import useUniqueId from 'hooks/useUniqueId';
import Modal from 'components/Modal';
import Card from 'components/Card';
import ModalHeadline from 'components/ModalHeadline';
import Panel from 'components/Panel';
import StickyButtonPanel from 'components/StickyButtonPanel';
import Flex from 'components/Flex';
import EmptyStateController from 'components/EmptyStateController';
import Text from 'components/Text';
import Button from 'components/Button';
import MeetingTranscript from '../MeetingTranscript';
import DownloadTranscriptMenu from '../DownloadTranscriptMenu';
import getTranscriptCopyText from './getTranscriptCopyText';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function TranscriptModal(_ref) {
  var meetingId = _ref.meetingId,
    userId = _ref.userId,
    meetingTitle = _ref.meetingTitle,
    meetingStartTime = _ref.meetingStartTime,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = useUniqueId();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    wasCopied = _useState2[0],
    setWasCopied = _useState2[1];
  var _useFetchUserMeetingT = useFetchUserMeetingTranscript({
      meetingId: meetingId,
      userId: userId
    }),
    data = _useFetchUserMeetingT.data,
    isLoading = _useFetchUserMeetingT.isLoading,
    isError = _useFetchUserMeetingT.isError;
  var hasTranscript = Boolean(data === null || data === void 0 ? void 0 : data.transcript.length);
  var copyText = data ? getTranscriptCopyText({
    meetingTitle: meetingTitle,
    transcript: data.transcript,
    hasTimings: data.hasTimings,
    unknownSpeakerLabel: t('modal_meeting_transcript_unknown_speaker')
  }) : '';
  var fileName = sanitizeForFileName([meetingTitle, t('modal_meeting_transcript_title'), meetingStartTime && getBasicDate(new Date(meetingStartTime))].filter(Boolean).join(' - '));
  return /*#__PURE__*/_jsx(Modal, {
    width: "extraWide",
    "aria-labelledby": titleId,
    onRequestClose: onClose,
    children: /*#__PURE__*/_jsxs(Card, {
      variant: "raised",
      overflow: "visible",
      children: [/*#__PURE__*/_jsx(ModalHeadline, {
        title: t('modal_meeting_transcript_title'),
        titleId: titleId,
        subtitle: meetingTitle,
        onClose: onClose
      }), /*#__PURE__*/_jsx(Panel, {
        children: /*#__PURE__*/_jsx(EmptyStateController, {
          isLoading: isLoading,
          isError: isError,
          isEmpty: !hasTranscript,
          emptyContent: /*#__PURE__*/_jsx(Text, {
            as: "p",
            children: t('modal_meeting_transcript_empty')
          }),
          children: data && /*#__PURE__*/_jsx(MeetingTranscript, {
            transcript: data.transcript,
            hasTimings: data.hasTimings
          })
        })
      }), /*#__PURE__*/_jsx(StickyButtonPanel, {
        children: /*#__PURE__*/_jsxs(Flex, {
          wrap: true,
          gap: "xs",
          children: [hasTranscript && /*#__PURE__*/_jsxs(Flex, {
            wrap: true,
            gap: "xs",
            children: [/*#__PURE__*/_jsx(CopyToClipboard, {
              text: copyText,
              onCopy: function onCopy() {
                return setWasCopied(true);
              },
              children: /*#__PURE__*/_jsx(Button, {
                variant: "default",
                icon: wasCopied ? 'ok' : 'asset',
                children: wasCopied ? t('alert_copied_to_clipboard') : t('actions_copy')
              })
            }), /*#__PURE__*/_jsx(DownloadTranscriptMenu, {
              meetingId: meetingId,
              userId: userId,
              fileName: fileName
            })]
          }), /*#__PURE__*/_jsx(Button, {
            variant: "primary",
            ml: "auto",
            onClick: onClose,
            children: t('actions_close')
          })]
        })
      })]
    })
  });
}
export default TranscriptModal;